import { render, staticRenderFns } from "./ViewOrderButton.vue?vue&type=template&id=f949c162&scoped=true"
import script from "./ViewOrderButton.vue?vue&type=script&lang=js"
export * from "./ViewOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f949c162",
  null
  
)

export default component.exports